module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_itr"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('em', [_vm._v("Introduction: Self-Care: The Ultimate Health Care")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c01"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("1")])]), _c('strong', [_vm._v("- Know Thyself and Love Thyself")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("2")])]), _c('strong', [_vm._v("- Karma Cleanse with Loving-kindness, Compassion, and Forgiveness")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("3")])]), _c('strong', [_vm._v("- Stress Less")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("4")])]), _c('strong', [_vm._v("- Embracing Mindfulness")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("5")])]), _c('strong', [_vm._v("- New Beginnings with “Beginner’s Mind”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("6")])]), _c('strong', [_vm._v("- The Power of Intention")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("7")])]), _c('strong', [_vm._v("- Just Say Om-ward")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("8")])]), _c('strong', [_vm._v("- Breathing Lessons")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("9")])]), _c('strong', [_vm._v("- Emotional Housecleaning")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("10")])]), _c('strong', [_vm._v("- Setting Healthy Boundaries")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("11")])]), _c('strong', [_vm._v("- Become a Physical Activist")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("12")])]), _c('strong', [_vm._v("- Sacred Love")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("13")])]), _c('strong', [_vm._v("- Clearing and Filling the Body: An Earthly Vessel for Spirit")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('span', {
    staticClass: "toc"
  }, [_c('strong', [_vm._v("14")])]), _c('strong', [_vm._v("- Come Back to Your Senses")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454926320_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clrtoc"
  }, [_c('em', [_vm._v("Acknowledgments")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30898c06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926320_toc.vue
// module id = 69
// module chunks = 0